let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("gq5gC")]).then(() => parcelRequire('5E2pR'));